module.exports = __webpack_public_path__ + "img/76352.edabfafc.svg";